
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { CardResults, CardPersonalBest } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { COURSES } from '../../../shared/constants';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';

export const AthleteTabpanel = ({ data, athleteId, onImportDsvBestTimes, isdsvLoading }) => {


    return (
        <TabPanel
        height={'calc(100vh - 160px)'}
            showNavButtons
            focusStateEnabled={false}
            deferRendering={false}

        >
            <TabPanelItem title='Bestzeiten'>
            <CardPersonalBest data={data?.personalbests} athleteId={athleteId} onImportDsvBestTimes={onImportDsvBestTimes} isdsvLoading={isdsvLoading}></CardPersonalBest>
            </TabPanelItem>
            <TabPanelItem title='Ergebnisse' >
             <CardResults results={data?.results} traininggroups={[]}></CardResults>
            </TabPanelItem>




        </TabPanel>
    );
};
